module.exports = __webpack_public_path__ + "img/579-42dfb3.png";